import * as React from 'react';
import { EmptyState } from '../../components/EmptyState';
import { IconButton } from '../../components/IconButton';
import { ListItem } from '../../components/ListItem';
import { Pane, Panes } from '../../components/Panes';
import { ListRenderer } from '../../components/ListRenderer';
import { AddIcon } from '../../icons/Add';
import { LocationsSyncStatusMessage } from '../../data/locations';
import { useHasPermission } from '../../auth';
import { Permissions, Customer } from '@rivison-inc/ft-types';
import { CalendarMonthIcon } from '../../icons/CalendarMonth';
import { theme } from '../../theme';
import { searchData } from '../../utils/filter';
import { sortByString } from '../../utils/sort';
import { useCustomers } from '../../data/customers';

function AddCustomerButton() {  
  return (
    <IconButton to="/customers/new" label="Add Customer">
      <AddIcon color={theme.palette.primary} />
    </IconButton>
  )
}

export function CustomerListPage() {
  const canRead = useHasPermission(Permissions.LOCATION_READ);  
  const { customers } = useCustomers();

  const [customerSearchText, setCustomerSearchText] = React.useState('');

  function getCustomerSearchData(data: Customer) {
    return [ 
      data.name || '', 
      data.address || '' ,
      data.city || '' ,
      data.postalCode || '' ,
      data.phone || '' ,
      data.email || '' ,
      data.contact || '' ,
    ];
  }

  const filteredCustomers = React.useMemo(() => {
    const ordered = sortByString(customers, 'name', 'asc');
    return searchData(ordered, getCustomerSearchData, customerSearchText);
  }, [customerSearchText, customers]);

  if (!canRead) {
    return <></>;
  }

  function renderRow(customer: Customer, idx: number) {
    return (
      <ListItem
        key={idx} 
        to={`/customers/${customer.id}`}
        title={customer.name || ''}
        subtitle={`${customer.address || ''} ${customer.city || ''} ${customer.province || ''}`}
      />
    )
  }

  return (
    <>
      <Panes
        id="customersPane"
        backgroundColor="light"
        height="full"
      >
          <Pane
            title="Customers"
            searchText={customerSearchText}
            onSearchChange={(searchText) => setCustomerSearchText(searchText)}
            icon={<CalendarMonthIcon />}
            rightButton={<AddCustomerButton />}
          >
            <>
              <LocationsSyncStatusMessage />
              <ListRenderer 
                render={(customer: Customer, idx: number) => renderRow(customer, idx)}
                data={filteredCustomers}
              />
              {!filteredCustomers.length && <EmptyState title={'No Customers'} subtitle={'Customers are groups of sites with billing information.'} image={'location'} />}
            </>
          </Pane>
      </Panes>
      
    </>
  )
}
